import { useMemo, useState } from 'react';

/** Checkbox selection limited to the rows currently on screen. */
export function useMaintenanceRowSelection(visibleIds: readonly string[]) {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const visible = useMemo(() => new Set(visibleIds), [visibleIds]);
  const selectedOnPage = useMemo(
    () => selectedIds.filter((id) => visible.has(id)),
    [selectedIds, visible],
  );

  return {
    selectedIds: new Set(selectedOnPage),
    selectedIdList: selectedOnPage,
    onToggle(id: string, selected: boolean) {
      setSelectedIds((current) =>
        selected ? [...new Set([...current, id])] : current.filter((item) => item !== id),
      );
    },
    onToggleAll(selected: boolean) {
      setSelectedIds(selected ? [...visibleIds] : []);
    },
    clear() {
      setSelectedIds([]);
    },
  };
}
